// extracted by mini-css-extract-plugin
export default {"pageLogoCont":"PageLogo_pageLogoCont__W9PLT","pageLogo":"PageLogo_pageLogo__XjAf2"};